import React, { Component } from 'react';
import img from '../../../assets/Admin/Manage_Invitations_Content/9e6515ba5e78239b8c958df4350e9d29_html_500048edfdba0535.png';
class ManageInvitationsContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Manage Invitations:</b></p>
                <p>Page Lists all Invitations lists sent to broke/ Agency . Admin can reinvite the broker/Agency to MiComp . Reinvite button is enabled after 72 hours from invitation sent time.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default ManageInvitationsContent;
